import { HeadModule } from "./HeadModule";
var Head = function Head2(props) {
  return null;
};
Object.assign(Head, HeadModule);
export {
  Head
};
//# sourceMappingURL=Head.android.js.map
